module.exports = __webpack_public_path__ + "img/us-quotation-popup-notpi@3x.5d3a9d2a.png";